__turbopack_context__.v({
  "contactLink": "toolsPara-module__rVM2FG__contactLink",
  "contentSection": "toolsPara-module__rVM2FG__contentSection",
  "contentText": "toolsPara-module__rVM2FG__contentText",
  "faqAnswer": "toolsPara-module__rVM2FG__faqAnswer",
  "faqContainer": "toolsPara-module__rVM2FG__faqContainer",
  "faqItem": "toolsPara-module__rVM2FG__faqItem",
  "faqQuestion": "toolsPara-module__rVM2FG__faqQuestion",
  "featuresList": "toolsPara-module__rVM2FG__featuresList",
  "footerLinks": "toolsPara-module__rVM2FG__footerLinks",
  "howToParaMain": "toolsPara-module__rVM2FG__howToParaMain",
  "howToUse": "toolsPara-module__rVM2FG__howToUse",
  "relatedToolItem": "toolsPara-module__rVM2FG__relatedToolItem",
  "relatedToolLink": "toolsPara-module__rVM2FG__relatedToolLink",
  "relatedToolsContainer": "toolsPara-module__rVM2FG__relatedToolsContainer",
  "sectionTitle": "toolsPara-module__rVM2FG__sectionTitle",
  "stepContainer": "toolsPara-module__rVM2FG__stepContainer",
  "stepList": "toolsPara-module__rVM2FG__stepList",
  "subHeading": "toolsPara-module__rVM2FG__subHeading",
  "tipContainer": "toolsPara-module__rVM2FG__tipContainer",
  "tipsList": "toolsPara-module__rVM2FG__tipsList",
  "useCaseContainer": "toolsPara-module__rVM2FG__useCaseContainer",
  "useCasesList": "toolsPara-module__rVM2FG__useCasesList",
});
